export class ItemFlatNode {
  constructor(
    public expandable: boolean,
    public id: number,
    public name: string,
    public seKey: string,
    public level: number
  ) { }
}
